import { ROLE_ACCESS_STORE_CONST } from '../actionConstants';

import { actionCreator, successFor, failedFor } from '../sagaUtil';

export const createRole = actionCreator(ROLE_ACCESS_STORE_CONST.CREATE_ROLE);

export const updateRole = actionCreator(ROLE_ACCESS_STORE_CONST.UPDATE_ROLE);

export const deleteRole = actionCreator(ROLE_ACCESS_STORE_CONST.DELETE_ROLE);

export const fetchAllRoles = actionCreator(ROLE_ACCESS_STORE_CONST.FETCH_ALL_ROLES);
export const setAllRoles = actionCreator(successFor(ROLE_ACCESS_STORE_CONST.FETCH_ALL_ROLES));
export const setRoleApiError = actionCreator(failedFor(ROLE_ACCESS_STORE_CONST.FETCH_ALL_ROLES));

export const fetchRolesAggregated = actionCreator(ROLE_ACCESS_STORE_CONST.FETCH_ROLES_AGGREGATED);
export const setRolesAggregated = actionCreator(successFor(ROLE_ACCESS_STORE_CONST.FETCH_ROLES_AGGREGATED));
export const setRolesAggregatedError = actionCreator(failedFor(ROLE_ACCESS_STORE_CONST.FETCH_ROLES_AGGREGATED));

export const setRoleModal = actionCreator(ROLE_ACCESS_STORE_CONST.SET_ROLE_MODAL);
export const setRoleModalData = actionCreator(ROLE_ACCESS_STORE_CONST.SET_ROLE_MODAL_DATA);

export const fetchEmployeeActiveRoles = actionCreator(ROLE_ACCESS_STORE_CONST.FETCH_EMPLOYEE_ACTIVE_ROLES);
export const setEmployeeActiveRoles = actionCreator(successFor(ROLE_ACCESS_STORE_CONST.FETCH_EMPLOYEE_ACTIVE_ROLES));
export const setEmployeeActiveRolesError = actionCreator(failedFor(ROLE_ACCESS_STORE_CONST.FETCH_EMPLOYEE_ACTIVE_ROLES));

export const fetchRoleEmployees = actionCreator(ROLE_ACCESS_STORE_CONST.FETCH_ROLE_EMPLOYEES);
export const setRoleEmployees = actionCreator(successFor(ROLE_ACCESS_STORE_CONST.FETCH_ROLE_EMPLOYEES));
export const setRoleEmployeesError = actionCreator(failedFor(ROLE_ACCESS_STORE_CONST.FETCH_ROLE_EMPLOYEES));

export const setRoleAccessFeature = actionCreator(ROLE_ACCESS_STORE_CONST.ROLE_ACCESS_FEATURE_DATA);
